import React from "react";
import {
  FormControlLabel,
  FormControlLabelProps,
  Radio as MuiRadio,
  styled,
} from '@mui/material';

export const Radio = styled((props: Omit<FormControlLabelProps, 'control'> & {control?: React.ReactElement<any, any>}) => (
  <FormControlLabel
    control={props.control || <MuiRadio />}
    {...props}
  />
))(({theme}) => ({
  padding: '2px 16px 2px 6px',
  display: 'flex',
  flex: 1,
  borderRadius: '8px',
  alignItems: 'center',
  border: '1px solid #C8CDD5',
  height: 48,
  [theme.breakpoints.up('md')]: {
    width: 'fit-content'
  },
  width: '100%',
  margin: 0,
  '& .MuiFormControlLabel-label': {
    fontSize: 18,
    lineHeight: '32px',
    fontWeight: 500,
    marginLeft: 7,
    whiteSpace: 'nowrap',
  },
}));
